import { render } from "./ContactoUp.vue?vue&type=template&id=1b5de21b&scoped=true"
import script from "./ContactoUp.vue?vue&type=script&lang=js"
export * from "./ContactoUp.vue?vue&type=script&lang=js"

import "./ContactoUp.vue?vue&type=style&index=0&id=1b5de21b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b5de21b"]])

export default __exports__